import { render, staticRenderFns } from "./editCampaignDialog.vue?vue&type=template&id=19ebd162&lang=pug"
import script from "./editCampaignDialog.vue?vue&type=script&lang=js"
export * from "./editCampaignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports